import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey5 } from 'approot/shared/styles/colours.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';

export const InteractiveViewport = styled.div`
  width: 100%;
  height: 100%;
  margin: auto;
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  overflow: hidden;
`;

export const InteractiveViewportInner = styled.div`
  position: relative;
  height: 100%;

  iframe {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    border: none;
    width: 100%;
    height: 100%;
  }
`;

export const InteractiveExpandModalInner = styled.div`
  max-height: calc(85vh - ${rem(40)});
  overflow-y: scroll;
`;
